<section class="map-marker-widget">
    <div id="map-{{mapData.id}}-annotation-{{annotationData.id}}" class="map">

    </div>
</section>